/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useContext, useEffect, useState } from 'react';
import {
  emailRegex,
  phoneRegex,
  conditionStateType,
  formObjectType,
  formObject,
  errorObject,
  customerInputArray,
  SubmitButtonClassVlaue,
  SubmitButtonDisabledClassVlaue
} from '../../types/regulatoryUpdateBundle';
import { useSubmitFormWithReCaptcha } from '../../hooks/custom';
import { usePostJson } from '../../hooks/services/regulatoryUpdateBundlePostJson';
import Form from './Form';
import {
  getPayloadObject,
  action,
  getThanksText,
  subjectTitle
} from '../../utils/regulatoryUpdatesBundle';
import GlobalContext from '../../contexts/GlobalContext';

type PrivacyPolicyFormProps = {
  customer: formObjectType;
  agent: formObjectType;
  setCustomerObject: Function;
  setAgentObject: Function;
  apiError: boolean;
  condition: conditionStateType;
  setApiError: Function;
  setThankYouScreenFlag: Function;
  actionSubjectValue: { actionValue: string; subjectValue: string };
  setSuccessScreenPopUpText: Function;
};

const PrivacyPolicyForm = (props: PrivacyPolicyFormProps): JSX.Element => {
  const { loginCheck, customerForm, agentForm } = props.condition;
  const {
    actionSubjectValue, customer, agent, apiError
  } = props;
  const { globalContext } = useContext(GlobalContext);
  const [customerError, setCustomerError] = useState(errorObject);
  const [submitClassValue, setSubmitClassValue] = useState(
    SubmitButtonClassVlaue
  );
  const [agentError, setAgentError] = useState(errorObject);
  const [phoneFomaterError, setPhoneFomaterError] = useState(false);
  const submitFormWithReCaptcha = useSubmitFormWithReCaptcha();
  const onError = () => {
    props.setApiError(true);
    setSubmitClassValue(SubmitButtonClassVlaue);
  };
  const onSuccess = () => {
    props.setSuccessScreenPopUpText(
      getThanksText(actionSubjectValue.subjectValue)
    );
    props.setThankYouScreenFlag(true);
    globalContext.gtm.setVirtualPage('Privacy_Request_Request_Submitted');
  };
  const [postJson] = usePostJson({ onSuccess: onSuccess, onError: onError });
  const getValidation = () => {
    let result = true;

    if (actionSubjectValue.subjectValue === 'CUSTOMER') {
      let errorObj = errorObject;

      if (customer.firstName === '') {
        errorObj = { ...errorObj, firstNameError: true };
        result = false;
      }

      if (customer.lastName === '') {
        errorObj = { ...errorObj, lastNameError: true };
        result = false;
      }

      if (customer.email === '') {
        errorObj = { ...errorObj, emailBlankError: true };
        result = false;
      } else if (!emailRegex.test(customer.email)) {
        errorObj = { ...errorObj, emailIncorrectError: true };
        result = false;
      }

      if (customer.phone === '') {
        errorObj = { ...errorObj, phoneBlankError: true };
        result = false;
      } else if (!phoneRegex.test(customer.phone)) {
        errorObj = { ...errorObj, phoneIncorrectError: true };
        result = false;
      }

      setCustomerError(errorObj);
    }

    if (actionSubjectValue.subjectValue === 'AGENT') {
      let customerErrorObj = errorObject;
      let agentErrorObj = errorObject;

      if (customer.firstName === '') {
        customerErrorObj = { ...customerErrorObj, firstNameError: true };
        result = false;
      }

      if (customer.lastName === '') {
        customerErrorObj = { ...customerErrorObj, lastNameError: true };
        result = false;
      }

      if (customer.email === '') {
        customerErrorObj = { ...customerErrorObj, emailBlankError: true };
        result = false;
      } else if (!emailRegex.test(customer.email)) {
        customerErrorObj = { ...customerErrorObj, emailIncorrectError: true };
        result = false;
      }

      if (customer.phone === '') {
        customerErrorObj = { ...customerErrorObj, phoneBlankError: true };
        result = false;
      } else if (!phoneRegex.test(customer.phone)) {
        customerErrorObj = { ...customerErrorObj, phoneIncorrectError: true };
        result = false;
      }

      if (agent.firstName === '') {
        agentErrorObj = { ...agentErrorObj, firstNameError: true };
        result = false;
      }

      if (agent.lastName === '') {
        agentErrorObj = { ...agentErrorObj, lastNameError: true };
        result = false;
      }

      if (agent.email === '') {
        agentErrorObj = { ...agentErrorObj, emailBlankError: true };
        result = false;
      } else if (!emailRegex.test(agent.email)) {
        agentErrorObj = { ...agentErrorObj, emailIncorrectError: true };
        result = false;
      }

      if (agent.phone === '') {
        agentErrorObj = { ...agentErrorObj, phoneBlankError: true };
        result = false;
      } else if (!phoneRegex.test(agent.phone)) {
        agentErrorObj = { ...agentErrorObj, phoneIncorrectError: true };
        result = false;
      }

      setCustomerError(customerErrorObj);
      setAgentError(agentErrorObj);
    }

    return result;
  };
  const submitForm = (e): void => {
    e.preventDefault();
    globalContext.gtm.pushVersionedEvent(
      '2.11',
      'CCPARequest',
      'ClickSubmitButton',
      'userLoggedInStatus= Loggedout ,requestType=' +
        actionSubjectValue.actionValue +
        ' ,userType=' +
        actionSubjectValue.subjectValue,
      null,
      true
    );

    if (getValidation()) {
      setSubmitClassValue(SubmitButtonDisabledClassVlaue);
      submitFormWithReCaptcha(
        postJson,
        getPayloadObject({
          customer: customer,
          actionSubjectValue: actionSubjectValue,
          action: action.CCPA,
          agent: props.agent
        }, globalContext.i18n.getText('phone_number_code'))
      );
    }
  };
  const removeErrorOnFocus = (value: string, title: string) => {
    if (title === subjectTitle.AGENT) {
      let newErrorCondition = agentError;

      if (value === customerInputArray[0].name) {
        newErrorCondition = { ...newErrorCondition, firstNameError: false };
      }

      if (value === customerInputArray[1].name) {
        newErrorCondition = { ...newErrorCondition, lastNameError: false };
      }

      if (value === customerInputArray[2].name) {
        newErrorCondition = {
          ...newErrorCondition,
          emailBlankError: false,
          emailIncorrectError: false
        };
      }

      if (value === customerInputArray[3].name) {
        newErrorCondition = {
          ...newErrorCondition,
          phoneBlankError: false,
          phoneIncorrectError: false
        };
      }

      setAgentError(newErrorCondition);
    }

    if (title === subjectTitle.CUSTOMER) {
      let newErrorCondition = customerError;

      if (value === customerInputArray[0].name) {
        newErrorCondition = { ...newErrorCondition, firstNameError: false };
      }

      if (value === customerInputArray[1].name) {
        newErrorCondition = { ...newErrorCondition, lastNameError: false };
      }

      if (value === customerInputArray[2].name) {
        newErrorCondition = {
          ...newErrorCondition,
          emailBlankError: false,
          emailIncorrectError: false
        };
      }

      if (value === customerInputArray[3].name) {
        newErrorCondition = {
          ...newErrorCondition,
          phoneBlankError: false,
          phoneIncorrectError: false
        };
      }

      setCustomerError(newErrorCondition);
    }

    if (props.apiError) {
      props.setApiError(false);
    }
  };

  useEffect(() => {
    setAgentError(errorObject);
    setCustomerError(errorObject);
    props.setCustomerObject(formObject);

    props.setAgentObject(formObject);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionSubjectValue.subjectValue]);

  return (
    <div>
      {loginCheck && customerForm && (
        <Form
          removeErrorOnFocus={removeErrorOnFocus}
          errorCondition={customerError}
          loginCheck={props.condition.loginCheck}
          customerForm={props.condition.customerForm}
          title={subjectTitle.CUSTOMER}
          formObject={customer}
          setFormObjectValue={props.setCustomerObject}
          phoneFomaterError={phoneFomaterError}
          setPhoneFomaterError={setPhoneFomaterError}
        />
      )}
      {loginCheck && agentForm && (
        <Form
          removeErrorOnFocus={removeErrorOnFocus}
          errorCondition={agentError}
          loginCheck={props.condition.loginCheck}
          customerForm={props.condition.customerForm}
          title={subjectTitle.AGENT}
          formObject={props.agent}
          setFormObjectValue={props.setAgentObject}
          phoneFomaterError={phoneFomaterError}
          setPhoneFomaterError={setPhoneFomaterError}
        />
      )}
      {apiError && (
        <div className="real-time-error regulatory-updates-error">
          Something went wrong
        </div>
      )}
      {loginCheck && (
        <div>
          <button
            className={submitClassValue}
            type="submit"
            onClick={(e) => submitForm(e)}>
            submit
          </button>
        </div>
      )}
    </div>
  );
};

export default PrivacyPolicyForm;
